import api from '../api';

export const independentProfileService = {
  getProfile: async () => {
    const response = await api.get('/independent/profile');
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await api.put('/independent/profile', profileData);
    return response.data;
  },

  changePassword: async (passwordData) => {
    const response = await api.put('/independent/profile/password', passwordData);
    return response.data;
  },

  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await api.post('/independent/profile/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
};

export default independentProfileService;
